// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
require("@rails/ujs").start();
// require("turbolinks").start();
require("@rails/activestorage").start();
require("channels");

import $, { param } from "jquery";
import "select2";
global.$ = jQuery;
global.toastr = require("toastr");
import "bootstrap";

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

import "bootstrap";
import flatpickr from "flatpickr";
document.addEventListener("turbolinks:load", () => {
  flatpickr("[data-behavior='flatpickr']", {
    altInput: true,
    altFormat: "F j, Y",
    dateFormat: "Y-m-d",
  });
});

require("flatpickr/dist/flatpickr.css");
import "select2/dist/css/select2.css";
import "./css/application";
// import "css/application";
window.addEventListener("DOMContentLoaded", () => {
  $(".select2").select2({ width: "100%" });
});

require.context("../images", true);

// Support component names relative to this directory:
var componentRequireContext = require.context("components", true);
var ReactRailsUJS = require("react_ujs");
ReactRailsUJS.useContext(componentRequireContext);

$(document).ready(function () {
  if (localStorage.getItem("role") != null) {
    requestRole(localStorage.getItem("role"));
  }

  $(".sign-up-btn").on("click", function () {
    var parameter = location.search;
    if (parameter != "") {
      var param = parameter.split("?")[1];
      var role = param.split("=")[1];
      localStorage.setItem("role", role);
    }
  });

  $("select:not(.role_category_select)").select2({ width: "100%" });

  // active url
  var current = location.pathname;
  $("a").each(function () {
    var $this = $(this);
    if ($this.attr("href") === current) {
      $this.addClass("active");
    }
  });

  // verify ad
  $(".is-verify").click(function () {
    adID = $(this).data("id");
    $("#cancel_ad").val(adID);
    $("#confirm_ad").val(adID);
  });

  // discount dynamic in publish form
  // remove row
  $("form").on("click", ".remove_record", function (event) {
    $(this).prev("input[type=hidden]").val("1");
    $(this).closest("tr").hide();
    return event.preventDefault();
  });

  // add row or field
  $("form").on("click", ".add_fields", function (event) {
    var regexp, time;
    time = new Date().getTime();
    regexp = new RegExp($(this).data("id"), "g");
    $(".fields").append($(this).data("fields").replace(regexp, time));
    return event.preventDefault();
  });

  // payment scripts
  var adID, adName;

  // set esewa payment link on pay button click
  $(".pay").click(function () {
    adID = $(this).data("id");
    adName = $(this).data("name");
    $("#pay-with-esewa").attr("href", `/payments/esewa_payment/${adID}`);
  });

  // Khalti Payment
  $("#getStartedModal").on("click", "#pay-with-khalti", function (event) {
    var config = {
      // replace the publicKey with yours
      publicKey: "live_public_key_880c958d5eae4d14bf1f710effa817f9",
      productIdentity: adID,
      productName: adName,
      productUrl: "https://sastoad.com/",
      paymentPreference: [
        "KHALTI",
        "EBANKING",
        "MOBILE_BANKING",
        "CONNECT_IPS",
        "SCT",
      ],
      eventHandler: {
        onSuccess(payload) {
          // on success call for verification and create payment
          $.ajax({
            type: "POST",
            url: "/payments/khalti_payment/" + adID,
            data: {
              payment: payload,
            },
            success: function (data) {
              if (data) {
                toastr.success("Payment Successfull");
                window.location.reload();
                return;
              }
              toastr.error("Error on Payment. Please try again");
            },
          });
        },
        onError(error) {
          toastr.error("Error on Transaction");
        },
      },
    };

    var checkout = new KhaltiCheckout(config);
    var btn = document.getElementById("pay-with-khalti");
    btn.onclick = function () {
      // fetch amount to be paid for advertisement
      $.ajax({
        url: "/ad_price",
        type: "get",
        data: {
          id: adID,
        },
        success: function (response) {
          checkout.show({ amount: response });
        },
        error: function (errorMessage) {
          toastr.error("Unable to fetch amount");
        },
      });
    };
  });

  // show hide password on click
  $("#eye").click(function () {
    if ($(this).hasClass("bx-hide")) {
      $(this).removeClass("bx-hide");
      $(this).addClass("bx-show");
      $(".password").attr("type", "text");
    } else {
      $(this).removeClass("bx-show");
      $(this).addClass("bx-hide");
      $(".password").attr("type", "password");
    }
  });
});

window.onConfirm = function (adID, status, showConfirm) {
  var callApi = true;
  if (showConfirm) {
    if (!confirm("Are you sure you want to " + status + " this ?")) {
      callApi = false;
    }
  }
  if (!callApi) {
    return;
  }
  $.ajax({
    url: "/publish_request",
    type: "post",
    dataType: "json",
    data: {
      id: adID,
      status: status,
    },
    success: function (data) {
      if (data.status == 11) {
        toastr.success(data.msg);
        location.reload();
      }
    },
    error: function (errorMessage) {
      toastr.error("Unable to publish request");
    },
  });
};

window.requestRole = function (data) {
  $.ajax({
    url: "/dashboard/reseller_and_subscriber",
    type: "get",
    dataType: "json",
    data: {
      type: data,
    },
    success: function (data) {
      if (data["status"] == 11) {
        toastr.success(data.msg);
      } else if (data["status"] == 22) {
        toastr.info(data.msg);
      } else {
        toastr.error("Unable to send request");
      }
      localStorage.removeItem("role");
    },
    error: function (errorMessage) {
      toastr.error("Unable to send request");
      localStorage.removeItem("role");
    },
  });
};
